const ADMIN_USERS_BASE = "/admin_api/admin_users";

async function adminUsersRequest(path, { method = "GET", csrfToken = "", body } = {}) {
  const headers = {};
  if (body !== undefined) headers["Content-Type"] = "application/json";
  if (csrfToken) headers["X-CSRF-Token"] = csrfToken;

  const response = await fetch(`${ADMIN_USERS_BASE}/${path}`, {
    method,
    credentials: "include",
    headers,
    body: body === undefined ? undefined : JSON.stringify(body),
  });

  const text = await response.text();
  let data;
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    throw new Error("The administration service returned an invalid response.");
  }

  if (!response.ok || data.success === false) {
    const error = new Error(data.message || `Request failed (${response.status}).`);
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
}

export function listAdminUsers({ page = 1, limit = 20, search = "", status = "" } = {}) {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });
  if (search.trim()) params.set("search", search.trim());
  if (status) params.set("status", status);
  return adminUsersRequest(`users.php?${params.toString()}`);
}

export function listAdminRoles() {
  return adminUsersRequest("roles.php");
}

export function createAdminUser({ name, email, password, roleIds }, csrfToken) {
  return adminUsersRequest("users.php", {
    method: "POST",
    csrfToken,
    body: { action: "create", name, email, password, role_ids: roleIds },
  });
}

export function updateAdminUser({ id, name, email, password, roleIds }, csrfToken) {
  return adminUsersRequest("users.php", {
    method: "POST",
    csrfToken,
    body: {
      action: "update",
      id,
      name,
      email,
      ...(password ? { password } : {}),
      role_ids: roleIds,
    },
  });
}

export function setAdminUserStatus(id, status, csrfToken) {
  return adminUsersRequest("users.php", {
    method: "POST",
    csrfToken,
    body: { action: "set_status", id, status },
  });
}
